import Logo from "../../assets/show_music_logo.svg";
import React, { useCallback, useRef } from "react";
import { Navigate } from "react-router-dom";
import { FormHandles } from "@unform/core";
import { Container, Content, Column } from "./styles";
import { Form } from "@unform/web";
import FormInput from "../../components/Form/FormInput";
import FormButton from "../../components/Form/FormButton";
import { FiLock, FiUser } from "react-icons/fi";
import * as Yup from "yup";
import getValidationErrors from "../../utils/getValidationErrors";
import { useAuth } from "../../hooks/Auth";
import { useToast } from "../../hooks/Toast";

interface ISignInFormData {
  user: string;
  password: string;
}

export const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { signIn, user } = useAuth();
  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: ISignInFormData) => {
      try {
        const schema = Yup.object().shape({
          user: Yup.string().required("Usuário obrigatório."),
          password: Yup.string().required("Senha obrigatória."),
        });

        await schema.validate(data, { abortEarly: false });
        formRef.current?.setErrors({});

        await signIn({ user: data.user, password: data.password });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err as Yup.ValidationError);
          formRef.current?.setErrors(errors);
          return;
        }
        addToast({
          type: "error",
          title: "Erro na autenticação.",
          description:
            "Ocorreu um erro ao fazer o login, cheque as credencias.",
        });
      }
    },
    [signIn, addToast]
  );

  return (
    <Container>
      <Content>
        <Column>
          <img src={Logo} alt="new hope logo" />
          <Form ref={formRef} initialData={{}} onSubmit={handleSubmit}>
            <FormInput name="user" icon={FiUser} placeholder="USUÁRIO" />
            <FormInput
              name="password"
              icon={FiLock}
              placeholder="SENHA"
              type="password"
            />
            <FormButton type="submit">Entrar</FormButton>
            {!!user && <Navigate to="/users" />}
          </Form>
        </Column>
      </Content>
    </Container>
  );
};
